import { CustomToastrAction, toastr } from "@/imports-files/common/common";
import { REDIRECT } from "@/imports-files/pages/clients/jobs/job";
import { CandidateListAction } from "@/services/components/candidate-listing-action";
import { AddCandidate } from "@/services/pages/candidates/add-candidate";
import {onCancelClick, setAutomationHash, manageAutomationTimer, TRANSLATION} from "@/imports-files/pages/candidates/add-candidate";
import { CandidateInfoEditService } from "@/services/components/candidate-info-edit-form";


export class AddCandidateActions
{
   constructor( setValue, setSuggestion, setAgencyUserSuggestion, setAgencyUserEmail)
    {
        this.setValue                  =   setValue;
        this.setSuggestion             =   setSuggestion;
        this.setAgencyUserSuggestion   =   setAgencyUserSuggestion;
        this.setAgencyUserEmail        =   setAgencyUserEmail;
        this.customToastrAction        =   new CustomToastrAction();
        this.candidateInfoEditService  =   new CandidateInfoEditService();
   }
    
  escapeRegexCharacters(str) 
  {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  async getSuggestions({value})
  {
    const escapedValue = this.escapeRegexCharacters(value?.trim());
    if (escapedValue === '') 
    {
       return [];
    }
    const userList = await this.candidateInfoEditService.getReferralUsers();
    return userList.data.referral_users;
  }

  getSuggestionValue(suggestion)
  {
      return suggestion
  }

  renderSuggestion(suggestion)
  {
      return <div> {suggestion}</div>
  }

  onSuggestionsFetchRequested = async (value) => { 
    var suggestion = await this.getSuggestions(value);
    this.setSuggestion(suggestion);
  }

  onSuggestionsClearRequested = () => { this.setSuggestion([])};
                
  shouldRenderSuggestions(value)
  {
    return value?.trim().length >= 3
  }
    
  renderInputComponent(inputProps, selectedValues, setSelectedValues, setSelectedUserCount, setValue, formik)
  { 
    return(<div className="buttonIn ShareCV">
              <input  className   = {PageStyle.Form__Input} autoComplete="password"  {...inputProps} />
              <Button buttonstyle = {`${ButtonStyle.nobgbutton} addbtn`} onClick={() => this.onAddClick(inputProps.value, selectedValues, setSelectedValues, setSelectedUserCount, setValue, formik)}>{TRANSLATION('button:add:default')}</Button>
          </div>)
  };

  onSuggestionSelectionEmail(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik)
  {
    this.add_selected_value_email(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik)
  }

  add_selected_value_email(value, selectedValues, setSelectedValues, setValue, setSelectedUserCount, formik)
  {
      var emails = [];

      for(var element of selectedValues)
      {
        emails.push(element.email);
      }

      if(!emails.includes(value.email))
      {
        selectedValues.push(value);
        setValue('');
        setSelectedValues(selectedValues);
        setSelectedUserCount(selectedValues.length);
      }
      else if( emails.includes(value.email) )
      {
         setValue('');
      }
  }

  getAgencyUserSuggestionValue(suggestion)
  {
    return suggestion.email
  }

  renderAgencyUserSuggestion(suggestion)
  {
      return <div> { suggestion.name ? `${suggestion.name} | ${suggestion.email}` :  `${suggestion.email}`}</div>
  }

  async getAgencyUserSuggestions(value, agencyUsers, setAgencyUsers)
  {
    const escapedValue = this.escapeRegexCharacters(value?.trim());
    if (escapedValue === '') 
    {
       return [];
    }
    let inputLength = escapedValue.length;
    return inputLength === 0 ? [] : agencyUsers.filter(user =>
      (user.name?.toLowerCase()?.slice(0, inputLength) === escapedValue) || (user.email.toLowerCase().slice(0, inputLength) === escapedValue)
    );
  }

  onAgencyUserSuggestionsFetchRequested = async (hash, agencyUsers,  setAgencyUsers) => { 
    var suggestion = await this.getAgencyUserSuggestions(hash.value, agencyUsers, setAgencyUsers);
    this.setAgencyUserSuggestion(suggestion);
  }

  onAgencyUserSuggestionsClearRequested = () => { this.setAgencyUserSuggestion([])};
            
}

export async function submitCandidate(args)
{
    args.setLoader(true);
    const formData = setCandidateFormData(args)
    var result = await new AddCandidate().createCandidate(formData);
    const customToastrAction  =   new CustomToastrAction();
    if(result?.data?.success)
    {
      if(args.from == "kanban")
      {
        // args.setShowCandidate(false)
        if(result.data.automations_hsh) setAutomationHash(args, result.data.automations_hsh)
        args.setJobData(result.data.kanban_data)
        if(result.data.automations_hsh) manageAutomationTimer({restart: args.restart, setTimerStatus: args.setTimerStatus  })
      }
      goToCandidateListingPage(args.router, args.from, args.formik, args.setIsDisabled);
      
      if(args.from == "kanban")
      {
        args.setShowCandidate(false)
      }

      customToastrAction.setNormalToastr(result.data.success, 'success');
      // toastr.success(result.data.success);
    }
    else
    {
      var error_hash    = result.response.data.error;
      var formik_values = args.formik.current.values.client_candidate;

      args.formik.current.setTouched({client_candidate: formik_values});
      if(error_hash.client_candidate) args.formik.current.setStatus({client_candidate: error_hash?.client_candidate});
      if(error_hash && typeof error_hash === 'string') customToastrAction.setNormalToastr(error_hash, 'error');
      args.setApiError(result.response);
      args.setLoader(false);
      if(result.response.data.duplicate_candidate) args.setDuplicateEmail({state: true, client_candidate_id: result.response.data.client_candidate_id, job_application_id: result.response.data.job_application_id, job_id: result.response.data.job_id, job_stage_id: result.response.data.job_stage_id })
    }
}

function setCandidateFormData(args){
  const formData            =   new FormData();
  const values              =   args.values

  formData.append( "client_candidate[name]",  values.client_candidate.name);
  formData.append( "client_candidate[first_name]",  values.client_candidate.first_name);
  formData.append( "client_candidate[last_name]",  values.client_candidate.last_name);
  formData.append( "client_candidate[email]",  values.client_candidate.email);
  formData.append( "client_candidate[contact_no]",  values.client_candidate.contact_no);
  formData.append( "client_candidate[social_media_detail_attributes][linkedin_url]",  values.client_candidate.social_media_detail_attributes.linkedin_url);
  formData.append( "client_candidate[social_media_detail_attributes][portfolio_url]",  values.client_candidate.social_media_detail_attributes.portfolio_url);
  formData.append( "client_candidate[location_attributes][full_address]",  values.client_candidate.location);


  if(args.from && args.from.length > 0 ) { formData.append( "from",  args.from); }
  // values.client_candidate.resume_attributes.file_type != '' ? formData.append( "client_candidate[resume_attributes][file_type]", 'cv') : '';
  values.client_candidate.resume_attributes.file      != '' ? formData.append( "client_candidate[cvs_attributes][][file]", values.client_candidate.resume_attributes.file, values.client_candidate.resume_attributes.file.name) : '';
  values.client_candidate.assign != '' ?  formData.append( "sourced", true) : '';
  values.client_candidate.assign != '' ?  formData.append( "client_candidate[job_slug]", values.client_candidate.assign) : '';
  values.client_candidate.assign != '' ?  formData.append( "sourced_option", values.client_candidate.sourced_option) : '';

  values.client_candidate.other_files_attributes.map((file, index) => {
      formData.append(`client_candidate[other_files_attributes][${index}][file_type]`, file.file_type)
      formData.append(`client_candidate[other_files_attributes][${index}][file]`, file.file, file.file_name)
      return file;
    })

  if(values.client_candidate.sourced_option == 'Referral')
  {
    formData.append("referrer_name", values.referrer_name||'');
  }

  if(values.client_candidate.sourced_option == 'Other')
  {
    formData.append("other_source", values.other_source||'');
  }

  if(values.client_candidate.sourced_option == 'Social' || values.client_candidate.sourced_option == 'Job Board')
  {
    formData.append("job_board_integration_attributes[integration_id]", values.client_candidate.job_board_integration_attributes.integration_id);
    formData.append("job_board_integration_attributes[integration_type]", values.client_candidate.job_board_integration_attributes.integration_type);
  }

  if(values.client_candidate.sourced_option == 'Agency' && values.client_candidate.agency_id)
  {
    formData.append("agency_id", values.client_candidate.agency_id ||'');
    formData.append("agency_user_email", values.client_candidate.agency_user_email ||'');
  }
  return formData
}

export async function getCandidateToken(args, duplicateEmail){
  args.setLoader(true);
  const formData = setCandidateFormData(args)
  var result = await new AddCandidate().candidateToken(formData, duplicateEmail);
  if(result?.request.status == 200){
    let selected_candidate_id = 'add_candidate_merge';
    let link = REDIRECT.client.jobs.merge_duplicate_users.replace('$candidate_id', result.data.client_candidate_id).replace('$duplicate_id', selected_candidate_id)
    const route_params = {applicant_id: result.data.job_application_id, job_id: result.data.job_id, candidate_token: result.data.candidate_token}
    args.setLoader(false);
    args.router.push({
        pathname: link,
        query: route_params
    })
  }
  else{
    args.setLoader(false);
  }
}


export async function getJobListData(params, t)
{
  var resultArray   = [{label: t('placeholder:select:please'), value: ''}]
  var sourcedOption = [{label: t('placeholder:select:please'), value: ''}]
  var agencies = [{label: t('placeholder:select:please'), value: '', users: []}]
  var integration_options = {social: [{label: t('placeholder:select:please'), value: '', type: "Integration"}], job_board: [{label: t('placeholder:select:please'), value: '', type: "Integration"}]}
  var result  =  await new CandidateListAction().ActiveJobList(params);

  if(result.status == undefined || result.status != 200)
  {
    const error = new Error('An error occurred while fetching the data.')
    error.status = result.response.status
    throw error
  }
  else
  {
    
    result.data.jobs.map((element) => {
      resultArray.push({label: element.label, value: element.slug})
      return element
    })
    // for(var element of result.data.jobs)
    // {
    //   console.log(`${element.label}`)
    //   var label = element.label
    //   var slug  = element.slug
    //   resultArray.push({label: label, value: slug})
    // }

    if(result.data.sourced_options && result.data.sourced_options.length > 0)
    {
        // for( var element of result.data.sourced_options)
        // {
        //   var label = element
        //   var value  = element
        //   sourcedOption.push({label: label, value: value})
        // } 
        result.data.sourced_options.map((element) => {
          sourcedOption.push({label: element.label, value: element.value})
          return element
        })
    }
    if(result.data.agencies && result.data.agencies.length > 0)
    {
      // for( var element of result.data.agencies)
      // {
      //   agencies.push({label: element.label, value: element.value, users: element.users, domain: element.domain})
      // } 
      result.data.agencies.map((element) => {
        agencies.push({label: element.label, value: element.value, users: element.users, domain: element.domain})
        return element
      })
    }
    if(result.data.integration_options && Object.keys(result.data.integration_options).length > 0)
    {
      result.data.integration_options.social.map((element) => {
        integration_options.social.push({label: element.label, value: element.value, type: element.type})
        return element
      })

      result.data.integration_options.job_board.map((element) => {
        integration_options.job_board.push({label: element.label, value: element.value, type: element.type})
        return element
      })
    }
    return {resultArray: resultArray, sourcedOption: sourcedOption, agencies: agencies, integration_options: integration_options};

  }

}

export function selectedIntegrationOption(options, job_board_integration_attributes)
{
  return options.filter((x) => x.value == job_board_integration_attributes?.integration_id && x.type == job_board_integration_attributes?.integration_type)
}

export function handleAssignValueOnChange(type, data, formik)
{
  if(type == 'sourced_options')
  {
    formik.setFieldValue("client_candidate.sourced_option", data.value);
  }
  else if(type == 'agency_id'){
    formik.setFieldValue("client_candidate.agency_id", data.value);
  }
  else
  {
    formik.setFieldValue("client_candidate.assign", data.value);
  }
}

export function goToCandidateListingPage(router, from, formik, setIsDisabled)
{
  if(from && from == "kanban")
  {
    onCancelClick();
    formik.current.resetForm();
    let hash = { file_type: '', file: '', file_name: ''};
    formik.current.setFieldValue('client_candidate.resume_attributes', hash);
    formik.current.setFieldValue('client_candidate.other_files_attributes',[]);
    document.getElementById('add_candidate_cv') ? document.getElementById('add_candidate_cv').value = "" : '';
    document.getElementById('additional_files_cv') ? document.getElementById('additional_files_cv').value = "" : '';
    setIsDisabled(false);    
  }
  else
  {
    var link = REDIRECT.client.candidates.candidate_listing;
    router.push(link);
  }
}


export function onAddCandidateRemoveFile(formik, type, index, setCvErrorMessage, setOtherErrorMessage, setFileCount, setIsDisabled, isAgency)
{
  if(type == "cv")
  {
    let hash = {
      file_type: '',
      file: '',
      file_name: ''
    }
    setIsDisabled(false)
    formik.setFieldValue('client_candidate.resume_attributes', hash)
    document.getElementById('add_candidate_cv') ? document.getElementById('add_candidate_cv').value = "" : '';
    setCvErrorMessage('')
  }
  else{
    if(isAgency){
      formik.values.client_candidate.other_files_attributes.map((x, agencyIndex) => {
        if(index == agencyIndex) x['_destroy'] = true
        else x['_destroy'] = false
        return x
      })
    }
    else{
      formik.values.client_candidate.other_files_attributes?.splice(index, 1);
    }
    document.getElementById('additional_files_cv') ? document.getElementById('additional_files_cv').value = "" : '';
    setOtherErrorMessage('');
    setFileCount(Math.random() * 10000);
  }
}

export function getAssignOptionsData(data, t){
  var resultArray   = [{label: t('placeholder:select:please'), value: ''}]
  var sourcedOption = [{label: t('label:sourced'), value: 'Sourced'}]
  var agencies = [{label: t('placeholder:select:please'), value: '', users: []}]
  var integrationOption = {social: [{label: t('placeholder:select:please'), value: '', type: "Integration"}], job_board: [{label: t('placeholder:select:please'), value: '', type: "Integration"}] }

  if(data.jobs)
  { for( var element of data.jobs)
    {
      var label = element.label
      var slug  = element.slug
      resultArray.push({label: label, value: slug})
    }
  }
  if(data.sourced_options && data.sourced_options.length > 0)
  {
    for( var element of data.sourced_options)
    {
      var label = element.label
      var value  = element.value
      sourcedOption.push({label: label, value: value})
    } 
  }
  if(data.agencies && data.agencies.length > 0)
  {
    for( var element of data.agencies)
    {
      agencies.push({label: element.label, value: element.value, users: element.users, domain: element.domain})
    } 
  }
  if(data.integration_options && Object.keys(data.integration_options).length > 0)
  {
    data.integration_options.social.map((element) => {
      integrationOption.social.push({label: element.label, value: element.value, type: element.type})
      return element
    })

    data.integration_options.job_board.map((element) => {
      integrationOption.job_board.push({label: element.label, value: element.value, type: element.type})
      return element
    })
  }

  data.jobs = resultArray
  data.sourced_options = sourcedOption
  data.integration_options = integrationOption
  data.agencies = agencies
  return data
}
